import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-othertrainings',
  templateUrl: './othertrainings.component.html',
  styleUrls: ['./othertrainings.component.css']
})
export class OthertrainingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
